import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';

interface PhoneInputProps {
  id: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  className?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  id,
  name,
  value,
  onChange,
  placeholder = 'Enter phone number',
  required = false,
  className = '',
}) => {
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    // Initialize display value
    if (value) {
      if (value.startsWith('+88')) {
        setDisplayValue(value.substring(3));
      } else {
        setDisplayValue(value);
      }
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    // Only allow numbers
    const numericValue = inputValue.replace(/\D/g, '');
    
    setDisplayValue(numericValue);
    
    // Create a synthetic event with the full phone number
    const fullPhoneNumber = numericValue ? `+88${numericValue}` : '';
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        name,
        value: fullPhoneNumber,
      },
    } as React.ChangeEvent<HTMLInputElement>;
    
    onChange(syntheticEvent);
  };

  return (
    <div className={`relative ${className}`}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Phone className="h-5 w-5 text-gray-400" />
      </div>
      <div className="absolute inset-y-0 left-10 flex items-center pointer-events-none">
        <span className="text-gray-500 text-sm font-medium">+88</span>
      </div>
      <input
        type="tel"
        id={id}
        name={name}
        value={displayValue}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        className="block w-full pl-20 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent sm:text-sm"
        style={{ fontFamily: 'var(--font-family)' }}
      />
    </div>
  );
};

export default PhoneInput;

